import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent, useCssModule, ref } from "vue";
import { Btn, Icon } from "linkd-ui";
export default defineComponent({
  props: {
    tag: {
      type: String,
      default: "button"
    },
    icon: {
      // 图标的iconfont定义名称
      type: String
    },
    size: {
      // 图标大小
      type: String,
      default: "12px"
    },
    iconcolor: {
      // 图标大小
      type: String
    },
    buttonType: {
      // 按钮样式，参考w-button
      type: String,
      default: "primary"
    },
    modeLine: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Btn,
    Icon
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    let p = null;
    if (props.modeLine) {
      p = {
        type: "default",
        mode: "line"
      };
    } else {
      p = {
        type: props.buttonType
      };
    }
    let iconNode = ref(null);
    if (props.icon) {
      iconNode.value = _createVNode("span", null, [_createVNode(Icon, {
        "name": props.icon,
        "color": props.modeLine ? "#666!important" : props.iconcolor,
        "class": props.buttonType == "primary" ? css.primary : css.default,
        "size": props.size,
        "fontClassName": "iconfont"
      }, null), _createTextVNode("\xA0")]);
    }
    return () => _createVNode(Btn, p, {
      default: () => [iconNode.value, ctx.slots.default?.()]
    });
  }
});